export const getPaginationTranslations = (translationsStrings = {}) => ({
  paginationCurrent: translationsStrings.pagination_current,
  paginationItem: translationsStrings.pagination_item,
  paginationNext: translationsStrings.pagination_next,
  paginationPrevious: translationsStrings.pagination_previous,
  paginationTitle: translationsStrings.pagination_title,
});

export const getProductCarouselTranslations = (translationsStrings = {}) => ({
  labels: {
    memberAccessLabel: translationsStrings.member_access_label,
    memberExclusiveText: translationsStrings.member_exclusive,
    nikeByYouLabel: translationsStrings.nike_by_you_label,
    nikeByYouText: translationsStrings.nike_by_you,
  },
});
